import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

export const useContactUs = () => {

  const [supportFeedback, setSupportFeedback] = useState({})


  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/notification/contact`, data)
        .then((res) => {
          return res.data;

        }),
    {
      onSuccess: (res) => {
        // @ts-ignore
        setSupportFeedback({
            open: true,
            status: 'success',
            message: 'Message sent successfully, we will reply as soon as possible.'
          })
  
      },
      onError: (error)=>{
        setSupportFeedback({
            open: true,
            status: 'error',
            message: error.message
          })
      }
    }
  );

  return {
      setSupportFeedback,
      supportFeedback,
    mutate,
    isLoading,
  };
};

